import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import './styles.scss';
import {Button, Dimmer, Dropdown, Grid, Loader} from 'semantic-ui-react';
import SelectedCard from '../../commons/selectedCardPriorization';
import {useSelector, useDispatch} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {deviceOptions} from '../../../constants/deviceOptions';
import moment from 'moment';
import {dateFormatShortMonth, noTimeZoneShortISODate} from '../../../../common/constants/datesFormat';
import {mapListToDropdownList} from '../../../../common/components/commercialTable/utils';

const {
  fetchAgenciesByDealer,
  fetchSuggestedPriorizationDates,
  cleanSuggestedPriorizationDates,
  savePriorization,
} = Actions;

export const stylesModal = {
  'overlay': {
    'background': 'rgba(0, 0, 0, 0.6)',
    'zIndex': 50,
    'padding': '0px',
  },
  'content': {
    'top': '50%',
    'left': '50%',
    'right': 'auto',
    'bottom': 'auto',
    'marginRight': '-50%',
    'transform': 'translate(-50%, -50%)',
    'padding': '0px',
    'overflow': 'visible',
  },
};

const INITIAL_PRIORIZATION_VALUES = {
  'dealer': '',
  'agency': '',
  'device': '',
  'combo': '',
};

const PriorizationModal = ({
  selectedData,
  openUpdateDates,
  setOpenUpdateDates,
  updateMyData,
}) => {
  const dispatch = useDispatch();
  const {combos, loadingSuggestedDates, suggestedDatesData} = useSelector((state) => state.priorizationDates);

  const listDealers = useSelector((state) => state.dealer.list);
  const {'agencies': listAgencies, 'loading': loadingAgencies} = useSelector((state) => state.accessoriesInvoicing);

  const [priorizationValues, setPriorizationValues] = useState(INITIAL_PRIORIZATION_VALUES);

  const [selectedPriorizationDates, setSelectedPriorizationDates] = useState([]);
  const [suggestedDates, setSuggestedDates] = useState([]);

  useEffect(() => {
    setSelectedPriorizationDates(selectedData.map((x) => {
      const alreadySelected = selectedPriorizationDates.find((y) => y.chassis === x.chassis);
      return {
        'chassis': x.chassis,
        'selectedDate': alreadySelected ? alreadySelected.selectedDate : '',
      };
    }));
  }, [selectedData]);

  useEffect(() => {
    setSelectedPriorizationDates(selectedPriorizationDates.map((x) => {
      return {...x, 'selectedDate': suggestedDatesData && suggestedDatesData.vehicleCapacityOcuped.length > 0 ?
        suggestedDatesData.vehicleCapacityOcuped.find((s) => s.chassis === x.chassis).prioritizationDateMod : ''};
    }));
    setSuggestedDates(suggestedDatesData?.calendar);
  }, [suggestedDatesData]);

  useEffect(() => {
    if (priorizationValues.dealer) {
      setPriorizationValues((prevValues) => ({...prevValues, 'agency': ''}));
      dispatch(fetchAgenciesByDealer({
        'dealerId': priorizationValues.dealer,
        'priorization': 'S',
      }));
    }
  }, [priorizationValues.dealer]);

  useEffect(() => {
    if (selectedData.length > 0 && priorizationValues.device && priorizationValues.combo) {
      const data = {
        'reservationId': selectedData[0].reservationId,
        'hunter': priorizationValues.device,
        'set': priorizationValues.combo,
        'vehicleArray': selectedData.map((x) => {
          return {
            'order': x.order,
            'line': x.line,
            'masterCode': x.masterCode,
            'sfx': x.sfx,
            'chassis': x.chassis,
          };
        }),
      };
      dispatch(fetchSuggestedPriorizationDates({'data': data}));
    }
  }, [priorizationValues.device, priorizationValues.combo]);

  const handleChange = (key, value) => {
    setPriorizationValues((prevValues) => ({...prevValues, [key]: value}));
  };

  const getInvoiceToData = () => {
    return selectedData.length > 0 ? selectedData[0].invoiceName : '';
  };

  const changeSelectedPrioritizationDate = (value, chassis) => {
    const selectedVehicleIdx = selectedPriorizationDates.findIndex((x) => x.chassis === chassis);

    const dateSelected = value.valueOf();
    const newCalendarItemIdx = suggestedDates.findIndex((x) =>
      moment(x.date, noTimeZoneShortISODate).toDate().valueOf() === dateSelected);

    const dateAssigned = moment(selectedPriorizationDates[selectedVehicleIdx].selectedDate,
      dateFormatShortMonth).toDate();
    const oldCalendarItemIdx = suggestedDates.findIndex((x) =>
      moment(x.date, noTimeZoneShortISODate).toDate().valueOf() === dateAssigned.valueOf());

    const newSuggestedDates = suggestedDates.map((item, index) => {
      if (index === newCalendarItemIdx) {
        return {...item,
          'quotationDisablePriorization': item.quotationDisablePriorization + 1,
        };
      }
      if (index === oldCalendarItemIdx) {
        return {...item,
          'quotationDisablePriorization': item.quotationDisablePriorization - 1,
        };
      }
      return item;
    });
    setSuggestedDates(newSuggestedDates);
    setSelectedPriorizationDates(selectedPriorizationDates.map((item, index) => {
      if (index === selectedVehicleIdx) {
        return {...item, 'selectedDate': value};
      }
      return item;
    }));
  };

  const disableSaveButton = () => {
    const result = !priorizationValues?.dealer || !priorizationValues?.agency ||
      !priorizationValues?.device || !priorizationValues?.combo;
    return result;
  };

  const savePriorizationHandler = (e) => {
    e.preventDefault();
    const data = {
      'reservationId': selectedData[0].reservationId,
      'dealerDestiny': priorizationValues.dealer,
      'agency': priorizationValues.agency,
      'hunter': priorizationValues.device,
      'set': priorizationValues.combo,
      'vehicleArray': selectedPriorizationDates.map((x) => {
        return {
          'chassis': x.chassis,
          'prioritizationDateMod': typeof x.selectedDate === 'object' ?
            moment(x.selectedDate).format(dateFormatShortMonth) : x.selectedDate,
        };
      }),
    };
    dispatch(savePriorization({'data': data}));
  };

  return (
    <>
      <Modal isOpen={openUpdateDates} style={stylesModal}>
        <Dimmer active={false} inverted>
          <Loader />
        </Dimmer>
        <div className='priorization-dates-modal-container'>
          <div className='priorization-dates-modal-container-col1'>
            <h3>
              LÍNEAS SELECCIONADAS
            </h3>
            <div className='priorization-container-mini-cards'>
              <SelectedCard
                data={selectedData}
                selectedPriorizationDates={selectedPriorizationDates}
                suggestedDates={suggestedDates}
                labels={{
                  'chassis': 'CHASIS',
                  'dealerName': 'DEALER',
                  'sfx': 'SFX',
                  'model': 'DESC.',
                }}
                updateMyData={updateMyData}
                changeSelectedPrioritizationDate={changeSelectedPrioritizationDate}
              />
            </div>
          </div>
          <div className='priorization-dates-modal-container-col2'>
            <h3>
              PRIORIZACIÓN
            </h3>
            <Grid columns={'2'} padded>
              <Grid.Row className='priorization-inputs-spacing'>
                <Grid.Column className='flex middle end str-label' width='8'>FACTURAR A:</Grid.Column>
                <Grid.Column textAlign='left' width='8' className='rm-space'>
                  {getInvoiceToData()}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className='priorization-inputs-spacing'>
                <Grid.Column className='flex middle end str-label' width='8'>CONCESIONARIO DESTINO:</Grid.Column>
                <Grid.Column textAlign='left' width='8' className='rm-space'>
                  <Dropdown basic fluid selection placeholder='Seleccionar' // disabled={isUserTDE}
                    value={priorizationValues.dealer}
                    options={mapListToDropdownList(
                      listDealers,
                      {
                        'keys': ['identification'],
                        'values': ['identification'],
                        'texts': ['name'],
                      })}
                    onChange={(e, {value}) => handleChange('dealer', value)}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className='priorization-inputs-spacing'>
                <Grid.Column className='flex middle end str-label' width='8'>AGENCIA DESTINO:</Grid.Column>
                <Grid.Column textAlign='left' width='8' className='rm-space'>
                  <Dropdown fluid selection placeholder='Seleccionar'
                    noResultsMessage='No se encontraron resultados...'
                    loading={loadingAgencies}
                    value={priorizationValues.agency}
                    options={!priorizationValues.dealer ? [] : listAgencies ? mapListToDropdownList(
                      listAgencies,
                      {
                        'keys': ['code'],
                        'values': ['code'],
                        'texts': ['name'],
                      }, true) : []}
                    onChange={(e, {value}) => handleChange('agency', value)}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className='priorization-inputs-spacing' >
                <Grid.Column className='flex middle end str-label' width='8'>DISPOSITIVO:</Grid.Column>
                <Grid.Column textAlign='left' width='8' className='rm-space'>
                  <Dropdown fluid selection placeholder='Seleccionar'
                    value={priorizationValues.device}
                    options={deviceOptions}
                    onChange={(e, {value}) => handleChange('device', value)}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className='priorization-inputs-spacing'>
                <Grid.Column className='flex middle end str-label' width='8'>COMBO:</Grid.Column>
                <Grid.Column textAlign='left' width='8' className='rm-space'>
                  <Dropdown fluid selection placeholder='Seleccionar'
                    value={priorizationValues.combo}
                    options={
                      mapListToDropdownList(
                        combos,
                        {
                          'keys': ['code'],
                          'values': ['code'],
                          'texts': ['code', 'description'],
                        },
                        false, ': ')
                    }
                    onChange={(e, {value}) => handleChange('combo', value)}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <div className='w-100 mt priorization-modal-order-cancel'>
              <Button
                type='button'
                basic
                className='toyota-secondary'
                size='small'
                onClick={() => {
                  setOpenUpdateDates(false);
                  setSuggestedDates([]);
                  setPriorizationValues(INITIAL_PRIORIZATION_VALUES);
                  dispatch(cleanSuggestedPriorizationDates());
                }}
              >
                    Cancelar
              </Button>
              <Button
                disabled={disableSaveButton()}
                loading={loadingSuggestedDates}
                type='button'
                primary
                className='toyota-secondary'
                size='small'
                onClick={(e) => savePriorizationHandler(e)}
              >
                    Guardar
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PriorizationModal;
